module.exports = __webpack_public_path__ + "img/ISO9001证书中文.a108f984.png";